<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="author" lang="en-US">Alysha Griffiths is a wife and mother to her beautiful daughter. She is a lifelong learner and passionate teacher who owns and runs her own tutoring centre, and enjoys writing in her free time. In addition to being a qualified teacher, her hidden talent is playing classical guitar and she can also play another five instruments as well. Alysha is based in Australia, she enjoys heading to the beach with her husband, daughter and extended family in her down time and is pretty sure she has visited every playground the country has to offer.</p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="c-heading ParaOverride-1" lang="en-US">Copyright © Alysha Griffiths 2024</p>
<p class="c-normal ParaOverride-1" lang="en-US">The right of <span class="CharOverride-1" lang="">Alysha Gri</span><span class="CharOverride-1" lang="">ff</span><span class="CharOverride-1" lang="">iths</span> to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="c-normal ParaOverride-1" lang="en-US">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="c-normal ParaOverride-1" lang="en-US">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="c-normal ParaOverride-1" lang="en-US">A CIP catalogue record for this title is available from the British Library.</p>
<p class="c-normal" lang="en-US">ISBN 9781398450424 (Paperback)</p>
<p class="c-normal ParaOverride-1" lang="en-US">ISBN 9781398450431 (ePub e-book)</p>
<p class="c-normal ParaOverride-1" lang="en-US">www.austinmacauley.co.uk</p>
<p class="c-normal ParaOverride-2" lang="en-US">First Published 2024<br/>Austin Macauley Publishers Ltd<span class="CharOverride-2" lang="">®</span><br/>1 Canada Square <br/>Canary Wharf <br/>London<br/>E14 5AA</p>
<p class="ded-next ParaOverride-1" lang="en-US">In loving memory of my beautiful aunty, Janis Brown.</p>
<p class="ded" lang="en-US">And to my lovely daughter, June.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="image" lang="en-US"><img alt="" class="_idGenObjectAttribute-2" src="image/9781398450424_txt6.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer044">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer045">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer047">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer048">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer049">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer050">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781398450424_txt24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer051">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled1.vue?b5fedae2